import Quill from 'quill';

const Embed = Quill.import('blots/embed');

class PlaceholderBlot extends Embed {
  static create(value) {
    console.log('📦 create() called for placeholder 1:', value);
    const node = super.create();
    // const node = document.createElement('span');
    console.log('📦 create() called for placeholder 2:', node);
    node.setAttribute('data-placeholder', value);
    node.setAttribute('contenteditable', 'false');
    node.classList.add('quill-placeholder');
    node.innerText = `{{ ${value} }}`;
    return node;
  }

  static value(node) {
    return node.getAttribute('data-placeholder');
  }
}

PlaceholderBlot.blotName = 'placeholder';
PlaceholderBlot.tagName = 'span';

Quill.register({ 'formats/placeholder': PlaceholderBlot });
